import { Box, Typography, SxProps, Theme } from "@mui/material";
import { Speed, GroupWork, VerifiedUser } from "@mui/icons-material";
import { SectionContainer } from "../../../modules/SectionContainer/SectionContainer";
import { SectionTitle } from "../../../modules/SectionTitle/SectionTitle";

const benefits = [
  {
    icon: <Speed sx={{ fontSize: 28, color: "#FFFFFF" }} />,
    title: "即戦力投入",
    description: "必要なスキルを持つエンジニアを迅速にアサインできる体制",
  },
  {
    icon: <GroupWork sx={{ fontSize: 28, color: "#FFFFFF" }} />,
    title: "柔軟なチーム編成",
    description: "プロジェクト規模に応じた最適な体制構築が可能",
  },
  {
    icon: <VerifiedUser sx={{ fontSize: 28, color: "#FFFFFF" }} />,
    title: "品質と効率の両立",
    description: "現役ハイスキルエンジニアによる効率的な開発が実現可能",
  },
];

export const GuildSection = () => {
  return (
    <SectionContainer sx={{ background: "#f8f9fa", padding: { md: "100px 0", xs: "60px 0" } }}>
      <SectionTitle sx={{ fontSize: { md: "36px", xs: "24px" } }}>
        200名超のハイスキルエンジニアと、共に動く。
      </SectionTitle>

      <Box sx={descriptionContainerSx}>
        <Typography sx={descriptionSx}>
          弊社が運営する「プログラマーズギルド」は、大手企業副業人材・ハイエンドフリーランスが集まるハイレベル人材コミュニティです。現役エンジニアが200名以上在籍。テクノスタンダードに入社することで、このコミュニティと連携しながら開発を進める環境があります。
        </Typography>
      </Box>

      <Box sx={benefitsContainerSx}>
        {benefits.map((benefit, index) => (
          <Box key={index} sx={benefitCardSx}>
            <Box sx={iconContainerSx}>{benefit.icon}</Box>
            <Typography sx={titleSx}>{benefit.title}</Typography>
            <Typography sx={benefitDescSx}>{benefit.description}</Typography>
          </Box>
        ))}
      </Box>
    </SectionContainer>
  );
};

const descriptionContainerSx: SxProps<Theme> = {
  maxWidth: "800px",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: { md: "32px", xs: "24px" },
};

const descriptionSx: SxProps<Theme> = {
  fontSize: { md: "16px", xs: "14px" },
  color: "#333333",
  lineHeight: 1.9,
  textAlign: "center",
};

const benefitsContainerSx: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: { md: "repeat(3, 1fr)", xs: "1fr" },
  gap: { md: "24px", xs: "16px" },
  marginTop: { md: "48px", xs: "32px" },
};

const benefitCardSx: SxProps<Theme> = {
  background: "linear-gradient(135deg, #22A1B9, #00BFA5)",
  borderRadius: "12px",
  padding: { md: "32px 24px", xs: "24px 20px" },
  textAlign: "center",
  transition: "all 0.3s",
  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: "0 8px 30px rgba(34, 161, 185, 0.4)",
  },
};

const iconContainerSx: SxProps<Theme> = {
  marginBottom: "16px",
};

const titleSx: SxProps<Theme> = {
  fontSize: { md: "18px", xs: "16px" },
  fontWeight: 700,
  color: "#FFFFFF",
  marginBottom: "12px",
};

const benefitDescSx: SxProps<Theme> = {
  fontSize: { md: "14px", xs: "13px" },
  color: "rgba(255, 255, 255, 0.9)",
  lineHeight: 1.7,
};
